import { DocumentModel } from '@/models/document.model';
import { ValidatorResult } from '@/models/validation-result.model';
import { AccountBalanceDto } from '@onrunning/backstage-models';
import { AccountingDocument } from '../models/accounting-document.model';
import { CrudService } from './crud.service';

export class AccountingDocumentsService {
  private accountingDocumentService: CrudService<AccountingDocument>;
  private documentService: CrudService<DocumentModel>;

  constructor() {
    this.accountingDocumentService = new CrudService<AccountingDocument>('accounting-documents');
    this.documentService = new CrudService<DocumentModel>('accounting-documents/documents');
  }

  public async getAll(accountId: string): Promise<ValidatorResult<AccountingDocument[]>> {
    return await this.accountingDocumentService.getAll('automatic', { params: { accountId } });
  }

  public async getDocument(documentId: string, accountId: string): Promise<ValidatorResult<DocumentModel>> {
    return await this.documentService.do('get', `${documentId}?accountId=${accountId}`, undefined, undefined, 'silent');
  }

  public async getBalance(accountId: string): Promise<ValidatorResult<AccountBalanceDto>> {
    return await this.accountingDocumentService.do('get', `balance?accountId=${accountId}`);
  }
}
